import { useEffect, useRef } from "react";

type IntervalFunction = () => unknown | void;

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
function useInterval(callback: IntervalFunction, delay: number, skipFirst: boolean = false) {
  const savedCallback = useRef<IntervalFunction | null>(null);

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    function tick() {
      if (savedCallback.current !== null) {
        savedCallback.current();
      }
    }
    if (!skipFirst) {
      tick();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [skipFirst, delay]);
}

export { useInterval };
